/**
 * A component that displays a table of uepms/products that have been replaced by another uepm
 */
export const ChargeAccountReplacedProductsTableComponent: ng.IComponentOptions = {
  bindings: {
    replacementUsageEventProductMappingId: '=',
    chargeAccountId: '@',
    onReplacedProductSelected: '='
  },
  templateUrl: 'app/angularJS/components/charge-account-replaced-products-table/charge-account-replaced-products-table.html',
  controller: 'ChargeAccountReplacedProductsTableController',
  controllerAs: 'vm'
};